"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEwsRequestDateString_1 = require("./utils/getEwsRequestDateString");
var applyConversationActionRequest_1 = require("owa-service/lib/factory/applyConversationActionRequest");
var conversationAction_1 = require("owa-service/lib/factory/conversationAction");
var folderId_1 = require("owa-service/lib/factory/folderId");
var itemId_1 = require("owa-service/lib/factory/itemId");
var targetFolderId_1 = require("owa-service/lib/factory/targetFolderId");
var applyConversationActionOperation_1 = require("owa-service/lib/operation/applyConversationActionOperation");
var Utils_1 = require("owa-service/lib/Utils");
/**
 * Create the flag conversationAction for the given conversation
 * @param conversationContext the conversation context to be flagged
 * @param flagType the flag type to apply
 * @param folderId the sourceFolderId
 * @returns the generated ConversationAction
 */
function createFlagConversationAction(conversationContext, flagType, folderId) {
    var flagAction = conversationAction_1.default({
        Action: 'Flag',
        ConversationId: itemId_1.default({ Id: conversationContext.conversationId }),
        Flag: flagType,
        ConversationLastSyncTime: getEwsRequestDateString_1.default(conversationContext.conversationLastSyncTimeStamp),
    });
    // folderId can be null in search mode.
    if (folderId) {
        var targetFolderId = targetFolderId_1.default({
            BaseFolderId: folderId_1.default({
                Id: folderId,
            }),
        });
        flagAction.ContextFolderId = targetFolderId;
    }
    return flagAction;
}
/**
 * Configure the request body
 * @param conversationIds the conversation ids
 * @param flagType the flag type to apply
 * @param folderId the folder id
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationContexts, flagType, folderId) {
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createFlagConversationAction(conversationContext, flagType, folderId);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
    });
}
/**
 * Sends out the service request to set flag on conversation
 * @param conversationContexts the conversation contexts to be deleted
 * @param flagType the flag type to apply
 * @param folderId the source folder id
 * @returns a Promise that handles the service request response
 */
function flagConversationService(conversationContexts, flagType, folderId) {
    var requestBody = configureRequestBody(conversationContexts, flagType, folderId);
    return applyConversationActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.flagConversationService = flagConversationService;
//# sourceMappingURL=flagConversationService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/services/flagConversationService.js
// module id = 5591
// module chunks = 62